import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { handleToggleTranscriptCreator } from 'creators/shareVideo';

import TranscriptHeader from './transcript-header';
import TranscriptWrapper from './transcript-wrapper';
import SharePageCard from '../share-page-card';
import { useMatchMedia } from 'hooks/useMatchMedia';
import { LARGE_TABLET_MAX_WIDTH } from 'constants/breakpoints';

interface TranscriptProps {
  height?: number;
  onRightPanel?: boolean;
}

function Transcript({
  height,
  onRightPanel = false,
}: TranscriptProps): JSX.Element {
  const dispatch = useDispatch();
  const [showFullHeader, setShowFullHeader] = useState(true);
  const onExit = useCallback(() => {
    dispatch(handleToggleTranscriptCreator());
  }, [dispatch]);

  const maxWidthTablet = useMatchMedia(
    `(max-width: ${LARGE_TABLET_MAX_WIDTH}px)`
  );

  // TODO: VV: this is not super readable
  const componentVisible =
    (maxWidthTablet && !onRightPanel) || (onRightPanel && !maxWidthTablet);

  return (
    <>
      {componentVisible && (
        <SharePageCard
          onRightPanel={onRightPanel}
          height={height}
          header={
            <TranscriptHeader showFullHeader={showFullHeader} onExit={onExit} />
          }
        >
          <TranscriptWrapper setShowFullHeader={setShowFullHeader} />
        </SharePageCard>
      )}
    </>
  );
}

export default Transcript;
